import React from 'react';
import Star from '../../foundations/pictograms/star.svg';
import { classNames } from '../../utils/style';

export interface PricingEngagementProps {
  label: string;
}

/**
 * Engagement component used in pricing cards to display features or benefits
 * with a star icon and label.
 */
export const Engagement = ({ label }: PricingEngagementProps) => {
  return (
    <div
      className={classNames('flex my-8 items-center text-neutral-101 text-12')}
    >
      <Star className="mr-8 w-12 h-12" /> {label}
    </div>
  );
};
